import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {take} from 'rxjs';
import {WebArchiveService} from 'src/app/webarchive/web-archive.service';
import {LoadComponent} from '@brunata-angular/ui';

@Component({
    standalone: true,
    imports: [LoadComponent],
    template: ` <app-load /> `,
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocViewerComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);
    private readonly router = inject(Router);
    private readonly webArchiveService = inject(WebArchiveService);

    ngOnInit(): void {
        this.route.queryParams.pipe(take(1)).subscribe(params => {
            const docId: unknown = params['docid'];

            if (typeof docId !== 'string') {
                this.navigateToNotFound();
                return;
            }

            this.webArchiveService.downloadDocument(docId, '_self').catch(() => {
                // An error will occur if the user is not logged in. In this case we don't want to show the 404 page.
                // To avoid showing the 404 page, we delay the redirect to wait for the redirect to the login page by
                // the auth system.
                setTimeout(() => {
                    this.navigateToNotFound();
                }, 1000);
            });
        });
    }

    private navigateToNotFound(): void {
        void this.router.navigate([`/not-found`], {
            queryParams: {url: encodeURIComponent(window.location.href)},
        });
    }
}
